import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { IssueDeactivationInstruction } from '../../../models';
import { IssueDeactivationInstructionService } from '../../../services';
import { DeactivationNotificationFormComponent } from '../deact-notification-form/deactivation-notification-form.component';

@Component({
  selector: 'nexweb-deactivation-supplying-bsp-notification',
  templateUrl: './deact-sup-bsp-not.component.html',
  imports: [DeactivationNotificationFormComponent, AsyncPipe],
})
export class DeactivationSupplyingBspNotificationComponent implements OnInit {
  @Input() bidId: number;

  public notification$: Observable<IssueDeactivationInstruction.DeactivationInstruction>;
  public dateTimeFormat: string;
  public labels: IssueDeactivationInstruction.Labels;
  public headings: IssueDeactivationInstruction.Headings;

  private bmFacade = inject(BmDataAccessFacade);
  private issueDeactivationInstructionService = inject(IssueDeactivationInstructionService);

  ngOnInit(): void {
    this.labels = this.issueDeactivationInstructionService.getNotificationLabels();
    this.headings = this.issueDeactivationInstructionService.getNotificationHeadings();
    this.dateTimeFormat = this.issueDeactivationInstructionService.getDateTimeFormat();

    this.initialiseData();
  }

  initialiseData(): void {
    this.notification$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          supplyingTsoName: bidNotificationInfo.supplyingTsoName,
          supplyingTsoTelephoneNumber: bidNotificationInfo.supplyingTsoPhoneNumber,
          bspPortfolio: bidNotificationInfo.supplyingBspPortfolioName,
          tsoName: bidNotificationInfo.requestingTsoName,
          tsoTelephoneNumber: bidNotificationInfo.requestingTsoPhoneNumber,
          tsoPortfolio: bidNotificationInfo.requestingTsoName,
          orderQuantity: bidNotificationInfo.requestedQuantity,
          confirmedFullDispatchTime: bidNotificationInfo.confirmedFullDispatchTime,
          fullyDeactivatedTime: bidNotificationInfo.deactivationDispatchTime,
        } as IssueDeactivationInstruction.DeactivationInstruction;

        return bidNotificationData;
      }),
    );
  }
}
